var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form',[_c('el-form-item',{attrs:{"label":_vm.label,"required":""}},[_c('el-input',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }